export default{sources:{avif:"__VITE_ASSET__BiTw6jGX__ 400w",webp:"__VITE_ASSET__Dq_gZPt6__ 400w"},img:{src:"__VITE_ASSET__tbEHa8Ba__",w:400,h:300}};